// Hlášení chyb do GlitchTipu (NFR-002, DEC-005): před odesláním se z události odstraní tělo
// požadavku, hlavička Authorization, cookies, `extra`, `contexts` a uživatel a v adresách se
// zamaskují tokeny (odkaz na výsledek, náhled, odkaz na test, pozvánka do páru, adresa obrazu). Čistá funkce bez
// závislosti na SDK.

const TOKEN_PATHS: readonly RegExp[] = [/(\/(?:cs|en)\/(?:r|preview|t|p)\/)[^/?#\s"]+/g, /(\/api\/v1\/(?:results|pictures)\/)[^/?#\s"]+/g];
const SECRET_HEADERS = /^(authorization|cookie|set-cookie|x-api-key|proxy-authorization)$/i;
/**
 * Vlastnické tokeny, klíče API a tokeny odkazů jsou base64url 43 znaků nebo `msk_…`. Hranice se
 * hlídá okolními znaky, ne `\b`: token smí začínat i končit pomlčkou.
 */
const BARE_TOKENS = /(?<![A-Za-z0-9_-])(?:msk_[A-Za-z0-9_-]{20,}|[A-Za-z0-9_-]{43})(?![A-Za-z0-9_-])|Bearer\s+[A-Za-z0-9._~+/=-]+/g;

/** E-mailová adresa (pojistka, adresa z pauzy se nikam neukládá ani neloguje, CR-013). */
const EMAILS = /[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}/g;

export function maskText(text: string): string {
  let out = text;
  for (const re of TOKEN_PATHS) out = out.replace(re, "$1***");
  return out.replace(BARE_TOKENS, "***").replace(EMAILS, "***@***");
}

type Bag = Record<string, unknown>;

function scrubRequest(req: Bag): Bag {
  const out: Bag = {};
  for (const [k, v] of Object.entries(req)) {
    if (k === "data" || k === "cookies") continue;
    if (k === "headers" && v !== null && typeof v === "object") {
      out[k] = Object.fromEntries(Object.entries(v as Bag).filter(([h]) => !SECRET_HEADERS.test(h)));
    } else if (typeof v === "string") out[k] = maskText(v);
    else out[k] = v;
  }
  return out;
}

export function scrubBreadcrumb<T extends object>(breadcrumb: T): T {
  const b = breadcrumb as Bag;
  const out: Bag = { ...b };
  if (typeof out["message"] === "string") out["message"] = maskText(out["message"]);
  if (out["data"] !== null && typeof out["data"] === "object") {
    out["data"] = Object.fromEntries(Object.entries(out["data"] as Bag).flatMap(([k, v]) => (k === "body" ? [] : [[k, typeof v === "string" ? maskText(v) : v]])));
  }
  return out as T;
}

/** Událost připravená k odeslání. Vrací kopii, vstup nemění. */
export function scrubEvent<T extends object>(event: T): T {
  const e: Bag = { ...(event as Bag) };
  delete e["extra"];
  delete e["contexts"];
  delete e["user"];
  if (e["request"] !== null && typeof e["request"] === "object") e["request"] = scrubRequest(e["request"] as Bag);
  if (Array.isArray(e["breadcrumbs"])) e["breadcrumbs"] = (e["breadcrumbs"] as Bag[]).map((b) => scrubBreadcrumb(b));
  if (typeof e["message"] === "string") e["message"] = maskText(e["message"]);
  const ex = e["exception"] as { values?: Bag[] } | undefined;
  if (ex?.values !== undefined) e["exception"] = { ...ex, values: ex.values.map((v) => (typeof v["value"] === "string" ? { ...v, value: maskText(v["value"]) } : v)) };
  return e as T;
}
